import type { Logger } from '@duda-co/ms-common-js';
import { logService } from '@duda-co/host-services';

// host-services' LogFields requires message/error to be present, but callers
// may pass arbitrary structured objects. The cast keeps the original escape
// hatch (previously implemented via Proxy<Logger>) while we forward to the
// single-arg sink.
const sink = logService as unknown as Record<
    keyof Logger,
    (payload: string | object) => void
>;

function buildPayload(
    data: string | object,
    meta?: Record<string, unknown>,
): string | object {
    if (typeof data === 'string') {
        return meta ? { message: data, ...meta } : data;
    }
    return { url: window.location.href, ...data, ...meta };
}

export const logger: Logger = {
    debug: (data, meta) => sink.debug(buildPayload(data, meta)),
    info: (data, meta) => sink.info(buildPayload(data, meta)),
    warn: (data, meta) => sink.warn(buildPayload(data, meta)),
    error: (data, meta) => sink.error(buildPayload(data, meta)),
};
